import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';
import type { ChatRoom } from '../types';
import { Avatar } from '../components/Avatar';

function ago(ts: number): string {
  const s = Math.max(0, (Date.now() - ts) / 1000);
  if (s < 60) return 'now';
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86400)}d`;
}

export function MessagesPage() {
  const [rooms, setRooms] = useState<ChatRoom[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  const load = () => api.chatRooms().then((r) => setRooms(r.rooms)).catch((e) => setError(e.message));
  useEffect(() => { load(); }, []);

  const hide = async (r: ChatRoom) => {
    if (!confirm(`Remove the conversation with ${r.peer.displayName}? It comes back if they message you.`)) return;
    await api.hideDm(r.roomId);
    load();
  };

  if (error) return <div className="error">{error}</div>;
  if (rooms === null) return <div className="spinner">Loading…</div>;
  if (rooms.length === 0) return <div className="empty">No conversations yet. Open someone's profile from a search and tap Message.</div>;

  return (
    <div className="card">
      {rooms.map((r) => (
        <div className="list-item" key={r.roomId}>
          <Link to={`/messages/${r.roomId}`} className="row" style={{ flex: 1, minWidth: 0, color: 'inherit' }}>
            <Avatar url={r.peer.photoUrl} name={r.peer.displayName} size="sm" />
            <div className="body">
              <div className="row between">
                <strong>{r.unread && <i className="dot" style={{ position: 'static', display: 'inline-block', marginRight: 6 }} />}{r.peer.displayName}</strong>
                <span className="muted small">{r.lastMessageAt ? ago(r.lastMessageAt) : ''}</span>
              </div>
              <div className="muted small" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{r.lastBody ?? 'Say hi'}</div>
            </div>
          </Link>
          <button className="icon-btn" onClick={() => hide(r)} aria-label="Remove">✕</button>
        </div>
      ))}
    </div>
  );
}
